export const CREATE_ORDER_BY_CONSULT_PACKAGE = 'CREATE_ORDER_BY_CONSULT_PACKAGE';
